import { render } from "./userPower.vue?vue&type=template&id=2112d744&scoped=true"
import script from "./userPower.vue?vue&type=script&lang=js"
export * from "./userPower.vue?vue&type=script&lang=js"

import "./userPower.vue?vue&type=style&index=0&id=2112d744&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2112d744"]])

export default __exports__